// eslint-disable-next-line no-undef
const envSettings = window;

export class Config {
    static get(key) {
        return envSettings[key];
    }
}
